import { render } from "./ElSocial.vue?vue&type=template&id=1720d131&lang=html"
import script from "./ElSocial.vue?vue&type=script&lang=js"
export * from "./ElSocial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__